import { ReactEChartsComponent } from './index';
import { summaryChartOption } from '../options';
import { Skeleton, Text } from '@pentabd/ui';
import { SummaryItemType } from '@type/dashboard';
import { numberLanguageFormatter } from '@utils/utils';

type SummaryCardPropsType = {
  id: number;
  name: string;
  divisionId: number;
  data: SummaryItemType | undefined;
  isLoading?: boolean;
};

export const SummaryCard = ({
  id,
  data,
  name,
  divisionId,
  isLoading,
}: SummaryCardPropsType) => {
  return (
    <div
      key={id}
      className={`col-span-sm-1 col-span-md-1 col-span-lg-1 col-span-xl-1 bg-${id} summary-card-custom d-grid grid-cols-5 rounded px-10`}
    >
      {isLoading ? (
        <div className="col-span-2 d-flex justify-content-center align-items-center">
          <Skeleton className="rounded-circle" height="90px" width="90px" />
        </div>
      ) : (
        <div className="col-span-2">
          <ReactEChartsComponent
            option={summaryChartOption(data?.percentage || 0)}
            handleQuery={(divisionId: number, asonId: number) => {}}
          />
        </div>
      )}

      <div className="col-span-3 py-10 d-flex flex-column justify-content-center align-items-end">
        {isLoading ? (
          <Skeleton
            className="rounded-4 mb-5 summary-title m-0 summary-card-text"
            height="30px"
            width="50%"
          />
        ) : (
          <div
            onClick={(e) => {
              e.preventDefault();
              const target = document.getElementById(
                `${divisionId}`,
              ) as HTMLElement;

              window.scrollTo({
                top: target ? target.offsetTop - 25 : 0,
                behavior: 'smooth',
              });
            }}
            className="pointer"
          >
            <Text
              weight="bold"
              component="h2"
              className="mb-5 summary-title m-0 summary-card-text"
              size="lg"
            >
              {name}
            </Text>
          </div>
        )}
        {isLoading ? (
          <Skeleton className="rounded-4" height="20%" width="70%" />
        ) : (
          <Text
            weight="semibold"
            component="p"
            className="text-end text-break summary-card-text"
            size="md"
          >
            {`${numberLanguageFormatter(
              data?.total_voters || 0,
            )} / ${numberLanguageFormatter(
              data?.total_vote_cast || 0,
            )} (${numberLanguageFormatter(data?.done_center_count || 0)}) `}
          </Text>
        )}
      </div>
    </div>
  );
};
